const ChipMap = {
    Flow: {
        id: 260098,
        name: 'Flow',
        type: 'struct',
        title: '颁奖流程',
        groupName: '盛典现场',
    },
    Prize: {
        id: 285361,
        name: 'Prize',
        type: 'recommend',
        title: '获奖案例',
        groupName: '获奖案例',
    },
    Prize2: {
        id: 285467,
        name: 'Prize2',
        type: 'recommend',
        title: '获奖案例',
        groupName: '获奖案例',
    },
    PrizeList: {
        id: 285467,
        name: 'PrizeList',
        type: 'recommend',
        title: '获奖案例',
        groupName: '获奖案例',
    },
    Talk: {
        id: 285353,
        name: 'Talk',
        type: 'recommend',
        title: '巅峰对话',
        groupName: '巅峰对话',
    },
    Talk2: {
        id: 285468,
        name: 'Talk',
        type: 'recommend',
        title: '巅峰对话',
        groupName: '巅峰对话',
    },
    Live: {
        id: 285354,
        name: 'Live',
        type: 'recommend',
        title: '直播',
        groupName: '盛典现场',
    },
    News: {
        id: 285355,
        name: 'News',
        type: 'recommend',
        title: '新闻动态',
        groupName: '盛典现场',
    },
    Pics: {
        id: 285356,
        name: 'Pics',
        type: 'recommend',
        title: '图集',
        groupName: '盛典现场',
    },
    Stars: {
        id: 285357,
        name: 'Stars',
        type: 'recommend',
        title: '明星助力',
        groupName: '盛典现场',
    },
    Alerter: {
        id: 260099,
        name: 'Alerter',
        type: 'struct',
        title: '弹窗控制',
        groupName: '弹窗控制',
    },
    YZALShow: {
        id: 221215,
        name: 'YZALShow',
        type: 'static',
        title: '优质案例展示',
        groupName: '优质案例展示',
    }
};

module.exports = { ChipMap };
